export const REVIEW_PROFILES_QUERY_KEY = 'ReviewProfiles';
